import React, { useState, useEffect } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { FaDownload } from "react-icons/fa";
import EmailNotificationAction from "../../../Actions/EmailNotificationAction";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import emailStore from "../../../Stores/EmailNotificationStore";
import EmailConstants from "../../../Constants/EmailNotificationConstants";
import { toast } from "react-toastify";
export default function DistributionGroupConfiguration({
  setList,
  scheduleEmailDetails,
  distributionGroupList,
  viewMode,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [distributionGroup, setDistributionGroup] = useState(
    distributionGroupList,
  );
  const [emailSchedularList, setEmailSchedularList] = useState(null);

  useEffect(() => {
    if (emailSchedularList) {
      setList(emailSchedularList);
    }
  }, [emailSchedularList]);

  useEffect(() => {
    let _itemList = [];
    if (distributionGroup) {
      if (scheduleEmailDetails) {
        const secondObjectMap =
          scheduleEmailDetails.emailDistributionGroupInfos.reduce(
            (map, item) => {
              map[item.emailDistributionGroupId] = item;
              return map;
            },
            {},
          );
        const thirdObject = distributionGroup.map((item) => {
          const _temp = secondObjectMap[item.id];
          if (!viewMode) {
            _itemList.push({
              groupName: item.groupTitle,
              type: _temp ? (_temp["isBefore"] ? "before" : "after") : "before",
              days: _temp ? _temp.days : 1,
              id: item["id"],
              frequency: _temp ? _temp.frequencyInDays : "",
              checked: _temp ? true : false,
            });
          } else if (_temp) {
            _itemList.push({
              groupName: item.groupTitle,
              type: _temp["isBefore"]
                ? localization.before
                : localization.after,
              days: _temp.days,
              id: item["id"],
              frequency: _temp.frequencyInDays,
              checked: true,
              lastSent: _temp.lastSent,
            });
          }
        });
      } else {
        distributionGroup.map((item) =>
          _itemList.push({
            groupName: item["groupTitle"],
            type: "after",
            days: 1,
            id: item["id"],
            frequency: "",
            checked: false,
          }),
        );
      }
    }
    setEmailSchedularList(_itemList);
  }, [distributionGroup]);

  useEffect(() => {
    function getEmailAttachmentSuccess() {
      var res = emailStore.getResult();
      if (res !== null && res !== undefined) {
        const url = window.URL.createObjectURL(res);
        let a = document.createElement("a");

        a.href = url;
        a.download = "ScheduleEmailAttachment.zip";
        a.click();
      }
      setGlobalSpinner(false);
    }

    function getEmailAttachmentFailure() {
      var res = emailStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    emailStore.addChangeListener(
      EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_SUCCESS,
      getEmailAttachmentSuccess,
    );

    emailStore.addChangeListener(
      EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_FAILURE,
      getEmailAttachmentFailure,
    );
    return () => {
      emailStore.removeChangeListener(
        EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_SUCCESS,
        getEmailAttachmentSuccess,
      );

      emailStore.removeChangeListener(
        EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_FAILURE,
        getEmailAttachmentFailure,
      );
    };
  }, []);

  function handleCheckSelection(_value, _index) {
    let _tempList = [...emailSchedularList];
    _tempList[_index]["checked"] = !_value["checked"];
    setEmailSchedularList(_tempList);
  }
  function handleValueChanges(event, index, _fieldName) {
    event.preventDefault();
    let _temp = [...emailSchedularList];
    _temp[index][_fieldName] = event.target.value;
    setEmailSchedularList(_temp);
  }

  function RenderDownload(_value) {
    const id = {
      schedule: scheduleEmailDetails.id,
      distributionGroupId: _value._detail,
    };

    return (
      <>
        <FaDownload
          className="cursorPoint svgIcon "
          size={20}
          title={localization.download}
          onClick={(e) => {
            e.preventDefault();
            setGlobalSpinner(true);
            EmailNotificationAction.getScheduleEmailAttachment(
              scheduleEmailDetails.id,
              _value._detail,
            );
          }}
        />
      </>
    );
  }
  if (emailSchedularList) {
    return (
      <>
        <div className="row mb-4 mt-4 pl-4 pt-2 pb-2 emailDistbutaion ">
          <h2 className="emailDistbutaionH1">
            {!viewMode
              ? localization.emailDistributinGroup
              : localization.summary}
          </h2>
        </div>

        {!viewMode && (
          <div className="row">
            <div className="col">{localization.distributionGroup}</div>
            <div className="col">{localization.beforeAfter}</div>
            <div className="col"> {localization.days}</div>
            <div className="col">{localization.frequency}</div>
          </div>
        )}
        {!viewMode &&
          emailSchedularList.map((item, index) => {
            return (
              <div className="row" key={index}>
                <div className="col mt-auto mb-auto" key={index}>
                  <input
                    type="checkBox"
                    id={item.groupName}
                    name={item.groupName}
                    defaultChecked={item.checked}
                    disabled={viewMode}
                    onChange={() => {
                      handleCheckSelection(item, index);
                    }}
                  />
                  <label className=" ml-5">{item.groupName}</label>
                </div>
                <div className="col">
                  {" "}
                  <div className="form-group">
                    <select
                      className="form-control"
                      id={"type" + index}
                      name="type"
                      required
                      disabled={viewMode}
                      value={item.type}
                      onChange={(e) => {
                        handleValueChanges(e, index, "type");
                      }}
                    >
                      <option value="before">{localization.before}</option>
                      <option value="after">{localization.after}</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <select
                      className="form-control"
                      id={"days" + index}
                      name="days"
                      value={item.days}
                      disabled={viewMode}
                      onChange={(e) => {
                        handleValueChanges(e, index, "days");
                      }}
                    >
                      {[...Array(31).keys()].map((day) => (
                        <option key={day + 1} value={day + 1}>
                          {day + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>{" "}
                <div className="col">
                  <div className="form-group d-flex">
                    <div
                      className="col pl-0 pr-0"
                      style={{ maxWidth: "max-content" }}
                    >
                      <label htmlFor={"frequency" + index}>
                        {localization.every}
                      </label>
                    </div>
                    <div className="col">
                      <input
                        type="number"
                        className="form-control"
                        value={item.frequency}
                        required={item.checked}
                        disabled={viewMode}
                        min={1}
                        id={"frequency" + index}
                        name="frequency"
                        onKeyPress={(e) => {
                          const isValidInput = /^[0-9\b]+$/.test(e.key);
                          if (!isValidInput) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          handleValueChanges(e, index, "frequency");
                        }}
                      />
                    </div>
                    <div className="col pl-0 pr-0">
                      <label htmlFor={"frequency" + index}>
                        {localization.days}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        {viewMode && (
          <table className="table align-middle mb-0 table-striped table-hover table-sticky">
            <thead className="bg-light">
              <tr>
                <th>{localization.distributionGroup}</th>
                <th> {localization.beforeAfter}</th>
                <th>{localization.days}</th>
                <th> {localization.frequency}</th>
                <th>{localization.lastSent}</th>
              </tr>
            </thead>
            <tbody>
              {emailSchedularList.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <label>{item.groupName}</label>
                    </td>
                    <td>
                      <label>{item.type}</label>
                    </td>
                    <td>
                      <label>{item.days}</label>
                    </td>
                    <td>
                      <label>
                        {localization.every +
                          " " +
                          item.frequency +
                          " " +
                          localization.days}
                      </label>
                    </td>
                    <td className="d-flex justifyContentSpaceBetw">
                      <label>{item.lastSent}</label>
                      {item.lastSent && <RenderDownload _detail={item.id} />}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </>
    );
  } else {
    return "";
  }
}
